import React, { memo } from 'react';

const Element = props => {
  return (
    <div id={props.name} />
  );
};

export default memo(Element, (prevProps, nextProps) => {
  if (prevProps.name !== nextProps.name) return false;
  return true;
});
